import React, {useContext, useEffect, useState} from "react";
import MDBox from "../../components/MDBox";
import CustomerHeader from "../common/CustomerHeader";
import Footer from "../Footer";
import CustomerPageLayout from "../Layout/CustomerPageLayout";
import Grid from "@mui/material/Grid";
import InventoryMiniPane from "./pane/InventoryMiniPane";
import {CompanyContext} from "../../lib/CompanyProvider";
import Meta from "../common/Meta";
import {getPreferenceValue} from "../common/Utils";

export default function CustomerMemberships(props) {
  const [companyContext, setCompanyContext] = useContext(CompanyContext);

  const [company, setCompany] = useState(companyContext?.company);


  useEffect(() => {
    if (companyContext?.company?.guid) {
      setPageReady(true);
      setCompany(companyContext.company);
    }
  }, [companyContext?.company]);

  const [pageReady, setPageReady] = useState(false);


  return (
    <>
      <CustomerPageLayout>
        <Meta pageTitle={'Passes & Memberships'}/>
        <CustomerHeader props={props}/>

        {pageReady && <MDBox m={3}>
            <Grid container cols={3} spacing={3} direction="row">
              <Grid item sm={12} xs={12}>
                <h1>
                  {companyContext?.company?.preferences && getPreferenceValue(companyContext?.company?.preferences, 'menu_item_passes', 'Passes')}
                </h1>
                <InventoryMiniPane
                  type={'membership'}
                />
              </Grid>
            </Grid>
        </MDBox>
        }

        <Footer/>
      </CustomerPageLayout>
    </>
  )
}